<template>
  <div class="_container">
    <!-- form login start -->
    <div class="login">
      <!-- image start -->
      <div class="image">
        <img src="../assets/favicon.png" alt="" />
      </div>
      <!-- image end -->

      <p>ເຂົ້າລະບົບ</p>
      <div v-if="errorMessage" class="box-error">
        <div class="error_text">{{ errorMessage }}</div>
      </div>
      <ValidationProvider rules="required|email" v-slot="{ errors }">
        <div class="input-text">
          <input class="input" type="email" v-model="mobile" />

          <label for=""><i class="far fa-envelope"></i> ອີເມວ</label>
        </div>
        <span style="font-size: 12px; color: red" id="error">{{
          errors[0]
        }}</span>
      </ValidationProvider>
      <!-- input email end

        input password start -->
      <ValidationProvider name="password" rules="required|min:6" v-slot="{ errors }">
        <div class="input-text">
          <input class="input" type="password" v-model="password" />

          <label for=""><i class="fas fa-lock"></i> ລະຫັດຜ່ານ</label>
        </div>
        <span style="font-size: 12px; color: red" id="error">{{
          errors[0]
        }}</span>
      </ValidationProvider>
      <!-- input password end

        button login start -->
      <div class="submit">
        <button @click="Login()" class="button is-primary is-rounded">
          <span>ເຂົ້າລະບົບ</span>
        </button>
      </div>
    </div>
    <!-- form login end -->
  </div>
</template>

<script>
import { AUTH_LOGIN } from "@/graphql/auth/auth";
import { apolloClient } from "../services/apollo-client";
import { AUTH_INFO } from '../graphql/auth/auth'
export default {
  data() {
    return {
      mobile: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async Login() {
      try {
        if (!this.mobile) return (this.errorMessage = "ກະລຸນາປ້ອນອິເມວກ່ອນ");
        if (!this.password)
          return (this.errorMessage = "ກະລຸນາໃສ່ລະຫັດຜ່ານກ່ອນ");
        const result = await apolloClient.mutate({
          mutation: AUTH_LOGIN,
          variables: {
            mobile: this.mobile,
            password: this.password,
          },
        });

        if (result.data.login) {
          this.$store.commit("setToken", result.data.login);
          localStorage.setItem("Token", result.data.login);
          // console.log(this.$store.getters['isAuth'])
          //console.log(this.$store.getters.Token)
          const res = await apolloClient.query({
            query: AUTH_INFO
          });
          this.$store.commit("setAuth", res.data.authInfo.permission)
          localStorage.setItem('authInfo', res.data.authInfo.permission)
          this.$router.push({ name: "home" });
        }
      } catch ({ graphQLErrors }) {
        const errorText = graphQLErrors[0].message;
        switch (errorText) {
          case "User does not exist!":
            return (this.errorMessage = "ອີເມວບໍ່ຖືກຕ້ອງ");
          case "Password Incorrect ":
            return (this.errorMessage = "ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error_text {
  color: red;
}

._container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(255, 255, 255);
  color: white;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  .login {
    position: relative;
    background-color: #5499c7;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.5);
    width: 650px;
    padding: 70px;
    border-radius: 10px;

    .image {
      top: -80px;
      left: 250px;
      position: absolute;
      width: 150px;
      height: 150px;

      img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        //border: 1px solid var(--primary-color);
      }
    }

    p {
      text-align: center;
      padding: 5px 0px;
      font-size: 25px;
      margin: 0;
    }

    .input-text {
      //margin-bottom: 5px;
      padding: 20px 0px 10px 0px;
      position: relative;

      label {
        position: absolute;
        top: 20px;
        left: 0;
        transition: 0.3s ease-out;
        pointer-events: none;
      }

      input {
        //margin-bottom: 20px;
        color: white;
        padding-top: 10px;
        padding-left: 0px;
        border-radius: 0%;
        border: none;
        border-bottom: 1px solid;
        outline: none;
        background-color: transparent;

        &:valid {
          padding-left: 10px;
        }
      }

      input:focus {
        border-bottom: 1px solid;
      }

      input:focus~label,
      input:valid~label {
        font-size: 15px;
        transform: translateY(-20px);
      }
    }

    .submit {
      width: 100%;
      text-align: center;
      padding: 25px 0 0 0;

      button {
        width: 150px;
      }

      button:hover {

        //background: $hover-color;
        span {
          color: var(--primary-color);
          font-weight: bold;
        }
      }
    }

    .reset_password {
      width: 100%;
      margin-top: 5px;
      text-align: right;

      a {
        color: white;
      }

      a:hover {
        color: var(--primary-color);
      }
    }
  }
}
</style>
